import * as React from "react";
import { NavLink } from "react-router-dom";
import { useOktaAuth } from "@okta/okta-react";
import { withRouter } from "utilities/withRouter";

import "./appHeader.css";
import commonUtilities from "utilities/common";
import Moment from "moment";
import "moment/locale/fr";

import Box from "@mui/material/Box";
import Avatar from "@mui/material/Avatar";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import IconButton from "@mui/material/IconButton";
import Logout from "@mui/icons-material/Logout";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import MenuIcon from "@mui/icons-material/Menu";
import { Link } from "react-router-dom";

const AppHeader = (props) => {
    const { authState, oktaAuth } = useOktaAuth();
    const auth = authState?.isAuthenticated;

    let userName = authState?.idToken?.claims?.name;

    let isIQMUser = commonUtilities.isIQMUser();

    const handleLogOut = () => {
        commonUtilities.clearStorage();
        oktaAuth.signOut();
    };

    const language = commonUtilities.getLanguage();

    if (language) {
        Moment.locale(language);

        const englishLinks = [
            {
                id: "1",
                linkText: "New group travel quote",
                target: "_self",
                url: "/home"
            },
            {
                id: "2",
                linkText: "Review all group quotes",
                target: "_self",
                url: "/review"
            }
        ];

        const frenchLinks = [
            {
                id: "1",
                linkText: "Nouveau devis de voyage de groupe",
                target: "_self",
                url: "/home"
            },
            {
                id: "2",
                linkText: "Revoir une Soumission déjà existant",
                target: "_self",
                url: "/review"
            }
        ];

        const links = language === "en" ? englishLinks : frenchLinks;

        const oktaWelcome = language === "en" ? "Hi" : "Bonjour";

        const [anchorAccountNameEl, setAnchorAccountNameEl] = React.useState(null);
        const openAccountNameMenu = Boolean(anchorAccountNameEl);

        const [anchorBurgerEl, setAnchorBurgerEl] = React.useState(null);
        const openBurgerMenu = Boolean(anchorBurgerEl);

        const handleAccountNameClick = (event) => {
            setAnchorAccountNameEl(event.currentTarget);
        };

        const handleAccountNameClose = () => {
            setAnchorAccountNameEl(null);
        };

        const handleBurgerClick = (event) => {
            setAnchorBurgerEl(event.currentTarget);
        };

        const handleBurgerClose = () => {
            setAnchorBurgerEl(null);
        };

        const currentRoute = props?.currentRoute;

        const getInitials = (name) => {
            if (!name) return "";

            return name
                .trim()
                .split(/\s+/)           // split by spaces
                .map(word => word[0])  // take first letter
                .slice(0, 2)           // max 2 initials
                .join("")
                .toUpperCase();
        };

        //isIQMUser = true;
        return (
            <div className="row app-header" data-testid="header-component">
                <header>
                    <div className="app-header-account">
                        <div className="app-header-wrapper">
                            <>
                                <Box className="account-info" sx={{ display: "flex", alignItems: "center", textAlign: "center" }}>
                                    <IconButton
                                        onClick={handleAccountNameClick}
                                        size="small"
                                        sx={{ ml: 2 }}
                                    >
                                        <span className="account-name">{oktaWelcome}, {userName}</span><Avatar className="account-name-initial" ><span>{getInitials(userName)}</span></Avatar>
                                    </IconButton>
                                </Box>
                                <Menu
                                    anchorEl={anchorAccountNameEl}
                                    id="account-name-menu"
                                    className="account-menu"
                                    open={openAccountNameMenu}
                                    onClose={handleAccountNameClose}
                                    onClick={handleAccountNameClose}
                                    transformOrigin={{ horizontal: "right", vertical: "top" }}
                                    anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
                                >
                                    
                                    <MenuItem onClick={handleLogOut}>
                                        <ListItemIcon>
                                            <Logout fontSize="small" />
                                        </ListItemIcon>
                                        {props.localize("qma-sign-out")}
                                    </MenuItem>
                                </Menu>
                            </>
                            
                        </div>
                    </div>
                   
                    <div className="app-header-container">
                        <div className="app-header-wrapper">
                            <AppBar className="app-bar" position="static">
                                <Toolbar>
                                    {isIQMUser ? null :
                                        (<Typography component="div" sx={{ flexGrow: 1 }} className="app-header-navigation">
                                            {links.map((link, index) => (
                                                <NavLink key={index} to={link.url} className={currentRoute === link.url ? "active" : "link"}>
                                                    {link.linkText}
                                                </NavLink>
                                            ))}
                                        </Typography>)
                                    }
                                    <Box className="account-info" sx={{ display: "flex", alignItems: "center", textAlign: "center" }}>
                                        <IconButton
                                            size="small"
                                            sx={{ ml: 2,  cursor: "default" }}
                                        >
                                            <span className="account-name">{oktaWelcome}, {userName}</span><Avatar className="account-name-initial" ><span>{getInitials(userName)}</span></Avatar>
                                        </IconButton>
                                    </Box>
                                    <IconButton
                                        onClick={handleBurgerClick}
                                        size="large"
                                        className="burger-menu-btn"
                                        edge="start"
                                        color="inherit"
                                        aria-label="menu"
                                        sx={{ mr: 2 }}
                                    >
                                        <MenuIcon />
                                    </IconButton>
                                </Toolbar>
                                <Menu
                                    anchorEl={anchorBurgerEl}
                                    id="burger-menu"
                                    className="account-menu"
                                    open={openBurgerMenu}
                                    onClose={handleBurgerClose}
                                    onClick={handleBurgerClose}
                                    transformOrigin={{ horizontal: "right", vertical: "top" }}
                                    anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
                                >
                                    {links.map((link, index) => (
                                        <MenuItem component={Link} to={link.url} key={index} className={currentRoute === link.url ? "active" : "link"}>
                                            {link.linkText}
                                        </MenuItem>
                                    ))}
                                    <MenuItem onClick={handleLogOut}>
                                        <ListItemIcon>
                                            <Logout fontSize="small" />
                                        </ListItemIcon>
                                        {props.localize("qma-sign-out")}
                                    </MenuItem>
                                </Menu>
                            </AppBar>

                            <div className="app-header-logo-background desktop">
                                {language === "en" ? (
                                    <img src="https://assets.sunwingtravelgroup.com/image/upload/v1752854260/WestJet/DIGITAL/WVI/WEBSITE/LOGOS/westjet-vacations-monotone-reverse.svg"/>
                                ) : (
                                    <img src="https://assets.sunwingtravelgroup.com/image/upload/v1752854260/WestJet/DIGITAL/WVI/WEBSITE/LOGOS/westjet-vacations-fr-monotone-reverse.svg"/>
                                )}
                            </div>

                            <div className="app-header-logo-background tablet mobile">
                                <img src="https://assets.sunwingtravelgroup.com/image/upload/v1751649540/WestJet/DIGITAL/WVI/WEBSITE/LOGOS/WVI_logo_White_leaf_icon.png"/>
                            </div>
                        </div>
                        
                    </div>
                </header>
            </div>
        );
    }
};

export default withRouter(AppHeader);